<template>
    <div style="width: 100%">

      <div style="width: 100%">
          <div class="header-table" style="font-size: 12px; margin-top: 10px;">

            <div style="display: flex; justify-content: space-between; margin-bottom: 10px">
              <div>
                <div>
                  Bill To, <br>
                  <strong>{{ saleInvoice?.customer?.company_name }}</strong><br/>
                  <strong>{{ saleInvoice?.delivery_address}}</strong><br>
                </div>

                <div>
                  <template v-if="saleInvoice?.customer?.contacts?.[0]">
                    <p><strong>Attention:</strong> {{ saleInvoice?.customer?.contacts?.[0]?.name }}</p>
                    <p><strong>Contact no:</strong> {{ saleInvoice?.customer?.contacts?.[0]?.mobile }}</p>
                  </template>
                </div>
              </div>
              <div>
                <p><strong>Invoice No:</strong> {{ saleInvoice?.code }}</p>
                <p><strong>Invoice Date:</strong> {{ formatDateView(saleInvoice?.sale_order_date) }}</p>
                <p><strong>Po Date:</strong> {{ saleInvoice?.po_date }}</p>
                <p><strong>Challan Date:</strong> {{ formatDateView(saleInvoice?.sale_invoice_delivery?.invoice_delivery_date) }}</p>
                <p><strong>PO/Ref No:</strong> {{ saleInvoice?.po_no }}</p>
                <p><strong>Challan No:</strong> {{ saleInvoice?.sale_invoice_delivery?.code }}</p>
              </div>
            </div>

          </div>
      </div>

      <div style="width: 100%">
          <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
            <thead>
            <tr>
              <th style="display:flex; justify-content: start; margin-bottom: 4px; border:none; padding: 3px">
                Item Details
              </th>
            </tr>
            </thead>
          </table>
      </div>

      <div style="width: 100%;">
        <table
          class="dep-table details-table"
          style="width: 100%; border-collapse: collapse; font-size: 12px;"
        >
            <thead>
              <tr>
                <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">SN</th>
                <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Code</th>
                <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Product Name & Grade</th>
                <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Unit</th>
                <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Lot No.</th>
                <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Qty.</th>
                <th v-if="isFreeItem" style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Free Qty.</th>
                <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Rate</th>
                <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Amount</th>
              </tr>
            </thead>
          <tbody>
            <template v-for="(row, idx) in saleInvoice?.details" :key="idx">
              <tr>
                <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ idx + 1 }}</td>
                <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.product?.code }}</td>
                <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: left;">{{ row.product?.name }} {{ row?.remarks && (`/ ${row.remarks}`) }}</td>
                <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.product?.unit?.name }}</td>
                <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.lot_no }}</td>
                <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.qty }}</td>
                <td v-if="isFreeItem" style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.free_qty }}</td>

                <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ row.sale_rate }}</td>
                <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ row.total }}</td>
              </tr>

                <!-- 🎁 Gift Rows -->
              <tr v-for="(gift, gIdx) in row.gifts || []"
                  :key="'gift-'+idx+'-'+gIdx">

                <td style="border:1px solid #E0E0E0; text-align:center;"></td>

                <td style="border:1px solid #E0E0E0; text-align:center;">{{ gift.product?.code }}</td>

                <td style="border:1px solid #E0E0E0; text-align:left;">
                  🎁 {{ gift.product?.name }}
                </td>

                <td style="border:1px solid #E0E0E0; text-align:center;">
                  {{ gift.product?.unit?.name }}
                </td>

                <td style="border:1px solid #E0E0E0; text-align:center;"></td>

                <td style="border:1px solid #E0E0E0; text-align:center;">
                  {{ gift.qty }}
                </td>

                <td style="border:1px solid #E0E0E0; text-align:center;">0</td>

                <td style="border:1px solid #E0E0E0; text-align:right;">{{ gift.sale_rate }}</td>

                <td style="border:1px solid #E0E0E0; text-align:right;">{{ gift.total }}</td>

              </tr>
            </template>

          </tbody>

        <tfoot>
            <tr>
            <td colspan="100%" style="border: none;">
              <table style="width: 100%; border-collapse: collapse;text-align: end; margin-top: 0px !important;">
                <tbody>
                  <tr>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; width: 86%; border-top: none !important;"><strong>SUBTOTAL</strong></td>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right; border-top: none !important;">{{ saleInvoice?.sub_total }}</td>
                  </tr>
                  <tr>
                    <td style="border: 1px solid #E0E0E0; padding: 2px;"><strong>DISCOUNT</strong></td>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.discount_amount }}</td>
                  </tr>
                  <tr>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-transform: capitalize;"><strong>VAT ({{ saleInvoice?.vat_type }})</strong></td>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.vat_amount > 0 ? saleInvoice?.vat_amount : '-' }}</td>
                  </tr>
                  <tr>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-transform: capitalize;"><strong>TAX ({{ saleInvoice?.tax_type }})</strong></td>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.tax_amount > 0 ? saleInvoice?.tax_amount : '-' }}</td>
                  </tr>
                  <tr>
                    <td style="border: 1px solid #E0E0E0; padding: 2px;"><strong>PAID</strong></td>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.paid }}</td>
                  </tr>
                  <tr>
                    <td style="border: 1px solid #E0E0E0; padding: 2px;"><strong>DUE</strong></td>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.due }}</td>
                  </tr>
                  <tr style="background-color: #f0f0f0;">
                    <td style="border: 1px solid #E0E0E0; padding: 2px; font-weight: bold;"><strong>TOTAL</strong></td>
                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right; font-weight: bold;">{{ saleInvoice?.total }}</td>
                  </tr>
                </tbody>
              </table>

              <div style=" display: flex; margin-top: 20px;">
                <p style="text-align: start;"><strong>In words: </strong></p>
                <p style="text-align: start;">{{ convertNumberToWords(saleInvoice?.sub_total) }}</p>
              </div>

              <div style=" display: flex; margin-top: 5px;">
                <p style="text-align: start;"><strong>Mode of payment: </strong></p>
                <p style="text-align: start;"> by A/C payee cheque in favour of "{{ saleInvoice?.branch?.company?.name }}"</p>
              </div>

              <div style=" margin-top: 5px; background-color: #ffffff;">
                <p><strong>Payment Terms: </strong></p>
                <p>{{ saleInvoice?.sale_order?.payment_terms || '-' }}</p>
              </div>
              <div v-if="saleInvoice?.payment_bank" style="margin-top: 5px; background-color: #ffffff;">
                <p><strong>Wire Transfer to following bank account: </strong></p>
                <table style="border-collapse: collapse;">
                  <tbody >
                    <tr>
                      <td style="border:none; width: 200px;">Account Name</td>
                      <td style="border:none;">:{{  saleInvoice?.payment_bank?.account_name? `${saleInvoice?.payment_bank?.account_name}`: ""  }}</td>
                    </tr>
                    <tr>
                      <td style="border:none;">Account Number</td>
                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.account_no? `${saleInvoice?.payment_bank?.account_no}`: ""  }}</td>
                    </tr>
                    <tr>
                      <td style="border:none;">Name of the Bank</td>
                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.name? `${saleInvoice?.payment_bank?.name}`: ""  }}</td>
                    </tr>
                    <tr>
                      <td style="border:none;">Branch Name</td>
                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.branch? `${saleInvoice?.payment_bank?.branch}`: ""  }}</td>
                    </tr>
                    <tr>
                      <td style="border:none;">Swift Code</td>
                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.swift_code? `${saleInvoice?.payment_bank?.swift_code}`: ""  }}</td>
                    </tr>
                    <tr>
                      <td style="border:none;">Routing No.</td>
                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.routing_no? `${saleInvoice?.payment_bank?.routing_no}`: ""  }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tfoot>
        </table>
      </div>
      </div>
</template>

<script>
import convertNumberToWords from '@/plugins/numberToWord';
import {formatDateView} from "@/plugins/helpers.js";

export default {
  name: "slsSaleInvoiceDetailsTable",
  data() {
    return {
      saleInvoice: null,
      
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    formatDateView,
    convertNumberToWords
  },
  setup(props, { emit }) { },
  
  mounted() {
    const id = this.$route.query.referenceable_id;

    this.$store.dispatch('getSaleInvoiceById', id)
      .then((res) => {
        this.saleInvoice = res;
      })

  },
};

</script>
